const loginTypes = [
  {
    name: "entities",
    endpoint: "/persons/exams/enterprises/login/",
    home: "/entidades/",
    activeCondition: /^\/entidades/,
    appID: 4,
  },
  {
    name: "lcci",
    endpoint: "/persons/exams/login/lcci/",
    home: "/lcci/",
    activeCondition: /^\/lcci/,
    appID: 3,
  },
  {
    name: "test",
    endpoint: "/persons/exams/login/",
    home: "/",
    activeCondition: /.*/,
    appID: 2,
  },
];

const getLoginType = () =>
  loginTypes.find((item) =>
    item.activeCondition.test(
      (typeof window !== "undefined" && window.location.pathname) || ""
    )
  );

export default getLoginType;
